import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';

const StyledToolbar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: ${({ theme }) => theme.spacing?.medium ?? '1rem'};
`;

const StyledActions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-shrink: 0;
  margin-left: auto;
`;

interface PageToolbarProps {
  search?: ReactNode;
  children?: ReactNode;
}

export const PageToolbar: FC<PageToolbarProps> = ({ search, children }) => (
  <StyledToolbar>
    {search}
    {children && <StyledActions>{children}</StyledActions>}
  </StyledToolbar>
);
